<template>
	<section> 
		<div class="d-flex align-items-center">
			<h1>Nouveau message</h1>
		</div>
		<div class="card">
			<h6>
				<span class="number-title">1</span>
				Sélectionnez un établissement 
			</h6>
			<div class="row">
				<div class="col-md-2 d-flex justify-content-center">
					<div class="container-avatar" :style="styleAvatar"></div>
				</div>
				<div class="col-md-10">
					<m-form-select
						label="Établissements"
						label-position="top"
						:name="$Utils.randomstring('establishmentsSelected')"
						v-model="establishmentsSelected"
						:items="establishments"
					/>
					<p v-if="!establishmentsSelected" class="alert alert-warning mt-2">
						Veuillez selectionner un établissement.
					</p>
					<p v-else class="alert alert-success mt-2">
						Cet établissement possède {{ boxes_total }} box dont {{ boxes.length }} active(s)
					</p>
				</div>
			</div>

			<h6>
				<span class="number-title">2</span>
				Définissez une cible 
			</h6>

			<div class="row">
				<div class="col mt-3 mb-3">

					<m-form-radio
						class="col-8"
						:label="`Le message s'adresse à l'ensemble des ${this.boxes_total} box de l'établissement`"
						name="targeted_boxes_mode"
						v-model="targetedBoxesMode"
						value="0"
						:disabled="!establishmentsSelected"
					/>
	
					<m-form-radio
						class="col-8 mt-1"
						label="Le message s'adresse à un nombre limité de box"
						name="targeted_boxes_mode"
						v-model="targetedBoxesMode"
						value="1"
						:disabled="!establishmentsSelected"
					/>

					<div class="row" v-show="targetedBoxesMode === '1'">
						<div class="col ml-3">

							<em-multiselect 
								v-model="selectedBoxes"
								:options="boxes"
								:searchable="true"
								:close-on-select="true" 
								:multiple="true"	
								track-by="name"
								label="name"
								:show-labels="false"
								placeholder="Rechercher"
								:disabled="!establishmentsSelected"
							/>

							<p v-if="!selectedBoxes.length" class="alert alert-warning mt-2">
								Aucune box n'est sélectionné
							</p>
							<p v-else class="alert alert-success mt-2">
								Vous avez sélectionné les box suivantes : {{ selectedBoxes.map(box => box.name).join(", ") }}
							</p>
						</div>
					</div>

				</div>
			</div>

            <v-schedule-message
                ref="schedulemessage"
                @saveplanning="savePlanningData"
                :inputPlanningObject="planning"
				:establishmentsSelected="establishmentsSelected"
            />

			<div class="row">
				<div class="col mt-2 mb-2 text-right">

					<button 
						type="button"
						class="btn btn-secondary text-right"
						@click="cancelMessage"
					>
						Annuler
					</button>

					<button 
						type="button"
						class="btn btn-primary text-right ml-2"
						@click="publishMessage"
						:disabled="sendBtnDisabled"
					>
						Publier
					</button>
				</div>
			</div>
        </div>
		<m-confirm-dialog
			v-model="publishConfirmDialog"
			title="Confirmation de la publication"
			:text="dialogConfirmText"
			width="500px"
			cancelText="Non"
			successText="Oui"
			@canceled="() => {this.publishConfirmDialog = false;}"
			@confirmed="publishMessageConfirmed"
		/>
  </section>
</template>

<script>

export default {
	name: "NewMessage",
	components: {},
	props: {
		value: {
			default: false,
			type: Boolean
		}
	},
	data() {
		return {
			establishments: [],
			establishmentsSelected: 0,
			messageTypes: [{
				text: "Texte et photo",
				value: 1
			}],
			selectBoxes: false,
			boxes_total: 0,
			boxes_current: "",
			boxes: [],
			selectedBoxes: [],
			connected_boxes_total: 0,
			targetedBoxesMode: "0",
			messageTypeSelected: 1,
			row_es: {},
			styleAvatar: "",
			planning: {},
			planningToSave: {},
			publishConfirmDialog: false
		};
	},

	watch: {

		establishmentsSelected(value) {

			if(!value) {
				this.selectBoxes = false;
				return;
			}

			let es = this.$_.find(this.$store.state.user.establishments, { es_id: value });

			if (es) {
				this.selectBoxes = true;
				this.styleAvatar = "background-image:url('" + this.$config.server_url + es.es_avatar + "')";
			}

			this.row_es = es;

			this.getEndusers();
		}
	},

	computed: {

		dialogConfirmText() {

			let allBoxes = this.boxes.length <= 1 ? "à l'unique" : `aux ${this.boxes.length}`;
			let fewBoxes = this.selectedBoxes.length <= 1 ? "à la" : "aux";

			let when = this.$moment().isSameOrAfter(this.planningToSave.pl_datedebut)
				? "immédiatement"
				: `le ${this.$moment(this.planningToSave.pl_datedebut).format("DD/MM/YYYY à HH:mm")}`;

			let to = this.targetedBoxesMode === '0'
				? `${allBoxes} box de l'établissement "${this.getEtbsName(this.establishmentsSelected)}"`
				: `${fewBoxes} box ${this.selectedBoxes.map(box => box.name).join(", ")} de l'établissement "${this.getEtbsName(this.establishmentsSelected)}"`

			return `Votre message sera envoyé ${when} ${to}. Souhaitez-vous le publier ?`;
		},

        sendBtnDisabled() {
            return !this.establishmentsSelected 
				|| this.boxes.length === 0 
				|| (this.targetedBoxesMode === "1" && !this.selectedBoxes.length)
				|| (!this.planningToSave.pl_message && !this.planningToSave.pl_messagemedia);
        }
	},

	mounted() {

		const plId = this.$route.params.pl_id;

		if(plId) {
			this.getScheduledMessage(plId);
		}

		let establishments = [];

		for (let i = 0; i < this.$store.state.user.establishments.length; i++) {

			const row_es = this.$store.state.user.establishments[i];

			establishments.push({
				text: row_es.es_name,
				value: row_es.es_id
			});
		}

		this.establishments = establishments;
		this.establishmentsSelected = establishments[0].value;
	},

	created() {},

	methods: {

		getEtbsName(value) {
			return (this.establishments
				.find(item => item.value === value) || {text: ""})
					.text;
		},

		publishMessage() {
			this.publishConfirmDialog = true;
		},

		cancelMessage() {
			this.$router.push("/messages");
		},

		async publishMessageConfirmed() {

			this.publishConfirmDialog = false;

			const enIds = (this.targetedBoxesMode === "0"
				? this.boxes
				: this.selectedBoxes)
				.map(box => box.en_id);

			this.planningToSave.en_ids = enIds;

			try {

				this.planningToSave.pl_sendtoall = this.targetedBoxesMode === "0" 
					? true 
					: false;

				let isEditing = this.planningToSave.pl_id 
					&& this.planningToSave.pl_id !== -1;
				
				let method = isEditing
					? "put"
					: "post";

				let putUrl = isEditing
					? `/${this.planningToSave.pl_id}`
					: "";

				let response = await this.$axios[method](`${this.$config.server_url}/extranet/2.0/plannings${putUrl}`, this.planningToSave);
				
				if (response.data.error) {
					this.$store.dispatch("showDialogError", response.data.err.message);
					return;
				}

				this.resetData();
				this.$emit("input", false);

				this.$router.push("/messages");

			} catch (error) {
				console.error(error);
			}
		},

		resetData() {
			this.styleAvatar = "";
			this.establishmentsSelected = 0;
			this.planningToSave = {};
			this.planning = {};
			this.$refs.schedulemessage.resetData();
		},

		async getEndusers() {

			let params = {
				types: [],
				bo_id: ">0",
				establishment: this.establishmentsSelected
			};

			this.cancelAxiosLoadContacts && this.cancelAxiosLoadContacts();

			let response = await this.$axios.get(this.$config.server_url + "/extranet/2.0/endusers", {
					params,
					cancelToken: new this.$axios.CancelToken(c => {
						this.cancelAxiosLoadContacts = c;
					})
				});

			if (!response || !response.data || !response.data.data) {
				return;
			}

			this.boxes = response.data.data
				.filter(box => {
					//return this.$store.state.connectedBoxes.includes(box.bo_id.bo_mac_address);
					return true;
				})
				.map(enduser => ({
					en_id: enduser.en_id,
					bo_id: enduser.bo_id instanceof Number ? enduser.bo_id : enduser.bo_id.bo_id,
					name: enduser.en_fullname,
					mac: enduser.bo_id ? enduser.bo_id.bo_mac_address : "pas de box",
				}));

			this.connected_boxes_total = this.boxes.length;
			this.boxes_total = response.data.meta.total;

			if(this.planning.en_ids) {
				this.selectedBoxes = this.boxes
					.filter(box => this.planning.en_ids.includes(box.en_id));
			}
		},

		savePlanningData(planning) {
			this.planningToSave = planning;
		},

		async getScheduledMessage(plId) {

			let response = await this.$axios.get(`${this.$config.server_url}/extranet/2.0/plannings/${plId}`);

			if (response && response.data && response.data.data) {	
				this.planning = response.data.data;
				this.targetedBoxesMode = response.data.data.pl_sendtoall ? "0" : "1";

				if(this.isCloneMode()) {
					this.planning.pl_id = -1
					this.planning.pl_datedebut = new Date();
				}

				this.restoreEstablishement();
			}
		},

		async restoreEstablishement() {

			let en_id = this.planning.en_ids[0];
			let response = await this.$axios.get(`${this.$config.server_url}/extranet/2.0/endusers/${en_id}`);

			if (response && response.data && response.data.data && response.data.data.co_id) {
				this.establishmentsSelected = this.$_.isObject(response.data.data.co_id.es_id)
					? response.data.data.co_id.es_id.es_id
					: response.data.data.co_id.es_id;
			}
		},

		isCloneMode() {
			return this.$route.fullPath.indexOf("/messages/clone") > -1;
		}
	}
};
</script>
<style scoped lang="scss">
@import "../scss/styles.scss";
.container-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-top: 8px;
  background-position: center;
  background-size: cover;
  border: 1px solid #b5b5b5;
  box-shadow: 2px 2px 6px 0px #d0d0d0;
}

// from WEBAPP
.avatar-message {
  width: 90%;
  margin: auto;
}
.btn-envoyer {
  width: 100%;
  margin-top: 20px;
  text-transform: uppercase;
  font-weight: 500;
}
input {
  margin-top: 20px;
}
.colWithoutPadding {
  padding-right: 10px;
}
.fileContainer {
  height: 50px;
  background-color: #ffffff;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 0;
  align-items: flex-end;
  border: 1px solid #ced4da;
  //   background-image: url("../../../public/assets/addphoto.png");
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
}
.labelImage {
  color: #6d6c64;
  font-size: 20px;
  padding: 10px;
  margin-bottom: 0;
}
textarea {
  font-size: 20px;
}

/****** toggle button  ******/
/* The switch - the box around the slider */
.switch {
  // float: left;
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  min-width: 60px;
  margin-right: 10px;
  margin-left: 10px;
}
/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #6da;
}

input:focus + .slider {
  box-shadow: 0 0 1px #6da;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.container-logout {
  text-align: left;
}
.btn-logout {
  text-align: left;
  background-color: #ffffff00;
  border: 0;
}
.iconMarginRight {
  width: 40px;
  width: 40px;
  height: 40px;
  opacity: 0.2;
}
</style>